module.exports = __webpack_public_path__ + "img/check-success.bcd6a306.svg";